import { CONTENT } from "@/content";
import { Wordmark } from "../ui/Wordmark";

type Props = {
  step: 0 | 1 | 2;
  onHome: () => void;
};

export function StepBar({ step, onHome }: Props) {
  return (
    <>
      <header className="fx-top">
        <Wordmark onClick={onHome} />
        <div className="fx-steps">
          {CONTENT.progress.map((s, i) => (
            <span key={i} style={{ display: "contents" }}>
              {i > 0 && <span className={`fx-sep ${i <= step ? "on" : ""}`} />}
              <div className={`fx-step ${i === step ? "on" : ""} ${i < step ? "done" : ""}`}>
                <span className="fx-dot">{i < step ? "✓" : i + 1}</span>
                <span className="fx-sname">{s}</span>
              </div>
            </span>
          ))}
        </div>
        <span className="fx-count">Etapa {step + 1} de 3</span>
      </header>
      <div className="fx-progress">
        <span style={{ width: `${((step + 1) / 3) * 100}%` }} />
      </div>
    </>
  );
}
